import { type ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";
import logo from "@/shared/assets/img/logo.png";
import bg from "@/shared/assets/img/login-bg.png";

interface Props {
  children: ReactNode;
}

export default function AuthLayout({ children }: Props) {
  const { t } = useTranslation("AuthLayout");

  return (
    <div className="flex-1 w-full grid grid-cols-[2fr_1fr] p-5 pt-0 gap-5">
      <div className="surface-base-fill radius-lg p-7 flex flex-col justify-between gap-7">
        <div className="flex justify-start">
          <img src={logo} height={48} width={92} alt="Logo" />
        </div>
        <div className="flex justify-center">{children}</div>
        <div className="flex justify-center items-center">
          <p className="text-center max-w-xl text-body-regular-xs content-base-low">
            <Trans
              i18nKey="disclaimer"
              t={t}
              components={{
                privacy: <a href="#" className="underline" />,
                terms: <a href="#" className="underline" />,
              }}
            />
          </p>
        </div>
      </div>

      <div
        className="radius-lg flex flex-col justify-end h-full bg-cover bg-center p-10"
        style={{ backgroundImage: `url(${bg})` }}>
        <div className="flex flex-col gap-3">
          <h2 className="text-white text-display-xs">{t("quote")}</h2>
          <p className="text-body-reguler-md text-white">{t("quoteAuthor")}</p>
        </div>
      </div>
    </div>
  );
}
